import React, { useState } from 'react';
import { Button } from '@mui/material';
import useStyles from './styles.js';
import QueueStatus from './QueueStatus.js';
import RedisManager from './RedisManager.js';
import BullManager from './BullManager.js';

const FixJobsView = () => {

  const classes = useStyles();
  const [filter, setFilter] = useState();

  return (
    <div className={classes.container}>
      <div className={classes.buttonContainer}>
        {/* <Button variant="contained" color="primary" onClick={() => setFilter('Jobs')}>
          Files d'attentes
        </Button> */}
        <Button variant="contained" color="primary" onClick={() => setFilter('Bull')}>
          Bull
        </Button>
        <Button variant="contained" color="primary" onClick={() => setFilter('Redis')}>
          Redis
        </Button>
      </div>
      {/* {filter && filter==='Jobs' && <QueueStatus/>} */}
      {filter && filter==='Bull' && <BullManager/>}
      {filter && filter==='Redis' && <RedisManager/>}
    </div>
  );
};

export default FixJobsView;